import type { UserName } from '../../api/types';

interface UserChipProps {
  user: UserName;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

// Liten cirkel med användarens initial. Färgen följer signaturpaletten:
// Henrik = blå, Michelle = röd. Används både i listor och i headers.
export function UserChip({ user, size = 'sm', className = '' }: UserChipProps) {
  const dimensions =
    size === 'lg'
      ? 'w-9 h-9 text-sm'
      : size === 'md'
        ? 'w-6 h-6 text-[10px]'
        : 'w-3.5 h-3.5 text-[8px]';

  const initial = user === 'henrik' ? 'H' : 'M';
  const bg = user === 'henrik' ? 'bg-henrik' : 'bg-michelle';

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-bold text-white ${bg} ${dimensions} ${className}`}
      title={user === 'henrik' ? 'Henrik' : 'Michelle'}
    >
      {initial}
    </span>
  );
}

// Avatar-par för headers ("HM"-stil med micro-overlap).
export function UserPair({ size = 'lg' }: { size?: 'sm' | 'md' | 'lg' }) {
  return (
    <div className="flex">
      <UserChip user="henrik" size={size} className="ring-2 ring-loupe-bg" />
      <UserChip
        user="michelle"
        size={size}
        className="-ml-2 ring-2 ring-loupe-bg"
      />
    </div>
  );
}
